import _taggedTemplateLiteral from "/builds/M9cfiv79/0/everlywell/apps/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import styled from "styled-components";
import { animated } from "react-spring";
import { size, typography } from "../../shared/constants";

var getArrowPosition = function getArrowPosition(o, t) {
  var r = {
    left: "",
    top: "",
    bottom: ""
  };
  return r.left = "left" === o ? "calc(0% + 30px)" : "right" === o ? "calc(100% - 42px)" : "calc(50% - 6px)", "bottom" === t ? r.top = "-6px" : r.bottom = "-6px", r;
},
    getBoxPosition = function getBoxPosition(o, t) {
  var r = {
    left: "",
    right: "",
    top: "",
    bottom: ""
  };
  return "bottom" === t ? r.top = "calc(100% + 14px)" : r.bottom = "calc(100% + ".concat(size.xs2, "px)"), "left" === o ? r.left = "calc(50% - 36px)" : "right" === o && (r.right = "calc(50% - 36px)"), r;
},
    TooltipChild = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]))),
    TooltipBox = animated(styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  --bg-color: ", ";\n\n  position: absolute;\n  border-radius: 2px;\n  max-width: 270px;\n  margin: 0 0 ", "px;\n  background-color: var(--bg-color);\n  padding: ", "px ", "px;\n  z-index: 10;\n\n  &::before {\n    content: '';\n    width: 0;\n    height: 0;\n    position: absolute;\n    border: 6px solid;\n    border-color: transparent transparent var(--bg-color) var(--bg-color);\n    transform: ", ";\n    transition: border 0.3s ease-in-out;\n    ", ";\n  }\n\n  ", ";\n"])), function (o) {
  return o.color;
}, size.xs1, size.xs1, size.md, function (o) {
  return "bottom" === o.position ? "rotate(135deg)" : "rotate(-45deg)";
}, function (o) {
  return getArrowPosition(o.arrow, o.position);
}, function (o) {
  return getBoxPosition(o.arrow, o.position);
})),
    TooltipContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-flow: column wrap;\n  align-items: center;\n"]))),
    TooltipContent = styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  --text-color: ", ";\n\n  ", ";\n  font-weight: ", ";\n  letter-spacing: 0.5px;\n  text-align: center;\n  color: var(--text-color);\n"])), function (o) {
  return o.textColor;
}, typography.captionText, typography.weight.book);

export { TooltipContainer, TooltipChild, TooltipBox, TooltipContent };